export enum WidgetSizes {
  half = 'half',
  full = 'full',
}
